import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import LoginPage from './components/LoginPage';
import AdminMobileHomeRedirect from './components/AdminMobileHomeRedirect';
import OverviewPage from './components/OverviewPage';
import InventoryPage from './components/InventoryPage';
import InventoryGalleryPage from './components/InventoryGalleryPage';
import RetailOrderPage from './components/RetailOrderPage';
import WholesaleOrderPage from './components/WholesaleOrderPage';
import AdminOrdersPage from './components/AdminOrdersPage';
import FinancePage from './components/FinancePage';
import LoginHistoryPage from './components/LoginHistoryPage';
import SettingsPage from './components/SettingsPage';
import AppLayout from './components/AppLayout';
import ProtectedRoute from './components/ProtectedRoute';
import ShopPage from './components/ShopPage.js';
import { ShopLanguageProvider } from './context/ShopLanguageContext';
import ProductDetailPage from './components/ProductDetailPage';
import ShopWholesaleBasketPage from './components/ShopWholesaleBasketPage';
import PricingPage from './components/PricingPage';
import DemoPage from './components/DemoPage';
import DemoShopPage from './components/DemoShopPage';
// Temporarily disabled session manager to fix authentication conflicts
// import sessionManager from './utils/sessionManager';

function App() {
  return (
    <BrowserRouter>
      <ShopLanguageProvider>
      <Routes>
        {/* Public storefront routes */}
        <Route path="/" element={<ShopPage />} />
        <Route path="/shop" element={<Navigate to="/" replace />} />
        <Route path="/shop/wholesale" element={<ShopWholesaleBasketPage />} />
        <Route path="/shop/:id" element={<ProductDetailPage />} />
        <Route path="/demo" element={<DemoPage />} />
        <Route path="/demo-shop" element={<DemoShopPage />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/login" element={<Navigate to="/admin/login" replace />} />

        {/* Admin routes */}
        <Route path="/admin/login" element={<LoginPage />} />
        <Route
          path="/admin/*"
          element={
            <ProtectedRoute>
              <AppLayout>
                <Routes>
                  <Route index element={<AdminMobileHomeRedirect />} />
                  <Route path="overview" element={<OverviewPage />} />
                  <Route path="dashboard" element={<Navigate to="/admin" replace />} />
                  <Route path="inventory" element={<InventoryPage />} />
                  <Route path="inventory/gallery" element={<InventoryGalleryPage />} />
                  <Route path="orders/retail" element={<RetailOrderPage />} />
                  <Route path="orders/wholesale" element={<WholesaleOrderPage />} />
                  <Route path="orders" element={<AdminOrdersPage />} />
                  <Route path="finance" element={<FinancePage />} />
                  <Route path="settings" element={<SettingsPage />} />
                  <Route path="login-history" element={<LoginHistoryPage />} />
                  <Route path="*" element={<Navigate to="/admin" replace />} />
                </Routes>
              </AppLayout>
            </ProtectedRoute>
          }
        />

        {/* Backward-compatible aliases for old admin URLs */}
        <Route path="/dashboard" element={<Navigate to="/admin/dashboard" replace />} />
        <Route path="/inventory" element={<Navigate to="/admin/inventory" replace />} />
        <Route path="/inventory/gallery" element={<Navigate to="/admin/inventory/gallery" replace />} />
        <Route path="/orders/retail" element={<Navigate to="/admin/orders/retail" replace />} />
        <Route path="/orders/wholesale" element={<Navigate to="/admin/orders/wholesale" replace />} />
        <Route path="/orders" element={<Navigate to="/admin/orders" replace />} />
        <Route path="/finance" element={<Navigate to="/admin/finance" replace />} />
        <Route path="/settings" element={<Navigate to="/admin/settings" replace />} />
        <Route path="/login-history" element={<Navigate to="/admin/login-history" replace />} />

        {/* Catch-all route for debugging */}
        <Route
          path="*"
          element={
            <div className="min-h-screen flex items-center justify-center">
              <div className="text-center">
                <h1 className="text-2xl font-bold text-red-600 mb-4">404 - Page Not Found</h1>
                <p className="text-gray-600 mb-4">The page you're looking for doesn't exist.</p>
                <p className="text-sm text-gray-500 mb-4">Current path: {window.location.pathname}</p>
                <div className="space-x-4">
                  <a href="/admin/login" className="admin-btn admin-btn-neutral px-4 py-2 rounded">
                    Go to Admin Login
                  </a>
                  <a href="/" className="admin-btn admin-btn-success px-4 py-2 rounded">
                    Go to Shop
                  </a>
                </div>
              </div>
            </div>
          }
        />
      </Routes>
      </ShopLanguageProvider>
    </BrowserRouter>
  );
}

export default App;
